import { render, staticRenderFns } from "./EditDatePicker.vue?vue&type=template&id=1bafcd0d&scoped=true"
import script from "./EditDatePicker.vue?vue&type=script&lang=ts"
export * from "./EditDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./EditDatePicker.vue?vue&type=style&index=0&id=1bafcd0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafcd0d",
  null
  
)

export default component.exports